<template>
  <section class="operation-result">
    <TextDisplay
      class="operation-result__text-display"
      title="Contribuição da operação"
      :value="customOperationData.operationFinancialVariation"
      show-tooltip
      tooltip-label="Entenda mais sobre o campo Contribuição da operação"
      @tooltip-click="
        handleTooltipClick(TooltipTypes.OperationFinancialVariation)
      "
    />
    <TextDisplay
      class="operation-result__text-display"
      title="Resultado total"
      :value="customOperationData.totalEarnings"
      show-tooltip
      tooltip-label="Entenda mais sobre o campo Resultado total"
      @tooltip-click="handleTooltipClick(TooltipTypes.TotalEarnings)"
    />
  </section>
</template>

<script lang="ts" setup>
import { TextDisplay } from '../TextDisplay';

import { CustomOperation } from '@/modules/trade/services/custom-operations';
import { TooltipTypes } from '../../types';

interface Props {
  customOperationData: CustomOperation;
}
defineProps<Props>();

interface Emits {
  (e: 'tooltip-click', type: TooltipTypes): void;
}
const emit = defineEmits<Emits>();

const handleTooltipClick = (type: TooltipTypes) => {
  emit('tooltip-click', type);
};
</script>

<style lang="less" scoped>
.operation-result {
  &__text-display {
    margin-top: @size-spacing-x500;
  }
}
</style>
